import React from 'react'
import useOffsets from '@/hooks/useOffsets'

const NAV_BAR_HEIGHT = 70

const STICKY_HEADER_HEIGHT = 70

const SafeAreaLayout = ({
  children,
  isStretch = false,
  hasNavBar = false,
  hasStickyHeader = false,
  customStickyHeaderHeight = 0,
}: {
  children: React.ReactNode
  isStretch?: boolean
  hasNavBar?: boolean
  hasStickyHeader?: boolean
  customStickyHeaderHeight?: number
}) => {
  const offsets = useOffsets()

  const getStickyHeaderHeight = () => {
    if (customStickyHeaderHeight) {
      return customStickyHeaderHeight
    }

    if (hasStickyHeader) {
      return STICKY_HEADER_HEIGHT
    }

    return 0
  }

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
        height: '100%',
        minHeight: '100dvh',
      }}
    >
      <div
        id="safe-area-layout"
        style={{
          paddingTop: offsets.top + getStickyHeaderHeight(),
          paddingBottom: offsets.bottom + (hasNavBar ? NAV_BAR_HEIGHT : 0),
          flex: 1,
          display: 'flex',
          flexDirection: 'column',
          overflowY: 'auto',
          WebkitOverflowScrolling: 'touch',
          ...(isStretch && { justifyContent: 'stretch' }),
        }}
      >
        {children}
      </div>
    </div>
  )
}

export default SafeAreaLayout
